export function BrandIntroSection() {
  return (
    <section
      id="nova"
      aria-labelledby="intro-title"
      className="relative overflow-hidden bg-white"
    >
      <img
        src="/assets/images/bg-gradient.png"
        alt=""
        aria-hidden="true"
        width="1920"
        height="640"
        className="bg-fill"
      />

      <div className="inner split-grid relative">
        <h2 id="intro-title" className="heading-2">
          <span className="heading-line font-normal">Nova 는</span>
          <span className="heading-line font-bold">완벽한 플랫폼.</span>
        </h2>

        <p className="flex justify-center lg:justify-end">
          <img
            src="/assets/images/logo-nova-lg.png"
            alt="Nova 브랜드 로고"
            width="568"
            height="164"
            className="h-auto w-full max-w-[568px]"
            loading="lazy"
          />
        </p>
      </div>
    </section>
  );
}
